<div class="column-matching-dialog">
    <h2 mat-dialog-title>Match Columns</h2>

    <mat-dialog-content>
        <div class="selected-column-info">
            <p>
                <strong>Selected Columns:</strong>
                <span *ngFor="let column of selectedColumns; let last = last">
                    {{ column?.name }}
                    <span *ngIf="!last">,</span>
                </span>
            </p>
            <p class="hint-text">Select matching columns from {{ sourceSide === 'source1' ? 'Source 2' : 'Source 1' }} below.</p>
        </div>

        <div class="matches-list" *ngIf="potentialMatches.length > 0">
            <div class="match-item" *ngFor="let match of potentialMatches" [class.selected]="match.matched">
                <mat-checkbox [checked]="match.matched" (change)="onMatchToggle(match)" class="match-checkbox">
                    <span class="column-name">{{ match.column?.name }}</span>
                    <span *ngIf="match.column?.inputType" class="column-type">({{ match.column?.inputType }})</span>
                </mat-checkbox>
            </div>
        </div>

        <div class="no-matches" *ngIf="potentialMatches.length === 0">
            <p>No columns available for matching on the opposite side.</p>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="selectedMatches.length === 0">
            Confirm ({{ selectedMatches.length }})
        </button>
    </mat-dialog-actions>
</div>
